import {IResource} from '@simpli/resource-collection'
import {TokensTableItemMarketInformation} from '@/model/resource/TokensTableItemMarketInformation'
import {Request} from '@simpli/serialized-request'
import {BlockchainVersion} from '@/model/resource/BlockchainVersion'

export class TokensTableItem implements IResource {
  idToken: number = 0
  imageUrl: string | null = null
  symbol: string | null = null
  blockchainVersion: BlockchainVersion | null = null
  marketInformation: TokensTableItemMarketInformation | null = null

  get displayMarketInformationNotAvailable() {
    if (
      !this.priceFormatted &&
      !this.priceVariationLastDayFormatted &&
      !this.priceVariationLastWeekFormatted &&
      !this.totalSupplyFormatted &&
      !this.marketCapFormatted &&
      this.isPriceVariationEmpty
    ) {
      return true
    }

    return false
  }

  get isPriceVariationEmpty() {
    if (
      !this.marketInformation ||
      !this.marketInformation.variationGraphValues ||
      !this.marketInformation.variationGraphValues.length
    ) {
      return true
    }

    return this.marketInformation.variationGraphValues.some(
      price => price === null
    )
  }

  get $id() {
    return this.idToken
  }

  get $tag() {
    return String(this.symbol)
  }

  get totalSupplyFormatted() {
    if (
      !this.marketInformation ||
      !this.marketInformation.totalSupply ||
      this.marketInformation.totalSupply === '0'
    ) {
      return null
    }

    return Number(this.marketInformation.totalSupply).toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: Number(this.marketInformation?.decimals ?? ''),
    })
  }

  get marketCapFormatted() {
    if (
      !this.marketInformation ||
      !this.marketInformation.marketCap ||
      this.marketInformation.marketCap === '0'
    ) {
      return null
    }

    return Number(this.marketInformation.marketCap).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }

  get priceFormatted() {
    if (!this.marketInformation || !this.marketInformation?.currentPrice) {
      return null
    }

    const currentPrice = this.marketInformation.currentPrice ?? '0'

    return Number(currentPrice).toLocaleString('en-US', {
      maximumFractionDigits: 12,
      minimumFractionDigits: 2,
      style: 'currency',
      currency: 'USD',
    })
  }

  get priceVariationLastDayFormatted() {
    if (
      !this.marketInformation ||
      !this.marketInformation.priceVariationLastDay
    ) {
      return null
    }

    return Number(this.marketInformation.priceVariationLastDay)
  }

  get priceVariationLastWeekFormatted() {
    if (
      !this.marketInformation ||
      this.marketInformation.priceVariationLastWeek
    ) {
      return null
    }

    return Number(this.marketInformation.priceVariationLastWeek)
  }

  async persistContract() {
    return await Request.post(`/client/contract`, this)
      .name('persistContract')
      .asNumber()
      .getData()
  }
}
